import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";
import {
  modalHeightVariants,
  modalVariants,
} from "../../animation/RoutesAnimations";
import ButtonComponent from "../elements/ButtonComponent";
import TextareaComponent from "../elements/TextareaComponent";
import { FieldError, useForm } from "react-hook-form";
import customZ from "../../utils/setZodCustomMessages";
import { notEmptyFieldText } from "../../utils/customSchemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { axiosPrivate } from "../../api/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { STORE_SELECT_STORE } from "../../api/apiClient";
import {
  IrequestProduct,
  ModalProps,
} from "../../pages/admin-dashboard/admin-dashboard-basicInfo/banks/type";

const StoreSelectModal: React.FC<ModalProps> = ({
  onClose,
  phone_number,
  telephone_number,
  address,
  modalType,
  name,
  province_name,
  city_name,
  setImSure,
  imSure,
  store_uid,
}) => {
  const requestProductSchema = customZ.object({
    request_product: notEmptyFieldText,
  });

  const {
    control,
    setValue,

    formState: { errors },
  } = useForm<IrequestProduct>({
    resolver: (data, context, options) => {
      return zodResolver(requestProductSchema)(data, context, options);
    },
  });

  const [requestProduct, setRequestProduct] = useState("");
  const access_token = localStorage.getItem("access_token");
  const [isLoading, setIsLoading] = useState(false);
  const [classnamesError, setClassnamesError] = useState("");
  const [isEmpty, setisEmpty] = useState(false);
  const [receivedValue, setReceivedValue] = useState("");

  const navigate = useNavigate();
  const handleValueReceived = (value: any) => {
    setReceivedValue(value);
    setRequestProduct(value);
  };

  useEffect(() => {
    if (receivedValue) {
      setValue("request_product", receivedValue);
    }
  }, [receivedValue]);

  useEffect(() => {
    setValue("request_product", receivedValue ? receivedValue : "");
  }, [setValue, receivedValue]);

  const onSubmit = async () => {
    const payload = {
      store_uid: store_uid,
      description: requestProduct,
    };
    if (true) {
      setIsLoading(true);
      setClassnamesError("");
      setisEmpty(false);
      try {
        const response = await axiosPrivate.post(STORE_SELECT_STORE, payload, {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
          },
          withCredentials: true,
        });
        if (response?.status >= 200 && response?.status < 300) {
          toast.success(`فروشگاه ${name} با موفقیت انتخاب شد`);
          setIsLoading(false);
          navigate("/");
        }
      } catch (error: any) {
        setIsLoading(false);
        console.error("An unexpected error occurred:", error);
        if (error?.request?.status === 401) {
          setIsLoading(false);
          toast.error(`
            شما به این بخش دسترسی ندارید.
            لطفا مجددا وارد پنل خود شوید.
            `);
        }
        if (error?.request?.status === 400) {
          setIsLoading(false);
          navigate("/fa/user-panel/orders");
        }
        if (error?.request?.status >= 500) {
          setIsLoading(false);

          toast.error(`ارتباط به درستی برقرار نشد`);
        }
      }
    }
  };

  return ReactDOM.createPortal(
    <motion.div
      variants={modalVariants}
      initial="initial"
      animate="final"
      id="static-modal"
      data-modal-backdrop="static"
      tabIndex={-1}
      aria-hidden="true"
      className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-screen bg-gray-500 bg-opacity-50"
    >
      <motion.div
        layout
        variants={modalHeightVariants}
        initial="initial"
        animate="final"
        className={`relative w-[380px] overflow-hidden bg-white rounded-lg shadow  ${
          modalType === "CallInformation"
            ? ""
            : imSure
            ? "w-[410px]"
            : "md:w-[380px] max-w-2xl"
        }`}
      >
        <motion.div
          layout={"position"}
          initial="initial"
          animate="final"
          className="relative"
        >
          <div className=" flex items-end justify-end rounded-t pt-2">
            <button
              type="button"
              onClick={onClose}
              className="text-gray-400 bg-transparent rounded-lg w-8 h-8 inline-flex justify-start items-center"
            >
              <img src="/icons/x.svg" alt="back icon" width={20} />
              <span className="sr-only">Close modal</span>
            </button>
          </div>

          {modalType === "CallInformation" ? (
            <div className="flex flex-col mt-1 m-10">
              <div className="flex flex-col justify-center items-center">
                <div className="flex flex-col items-center mx-auto bg-primary-100 p-2 rounded-full w-fit  justify-center gap-8 mb-5">
                  <img
                    src="/icons/store-outline.svg"
                    className="h-[36px]"
                    alt="logo vam30"
                  />
                </div>
                <p className="text-Title/14/Regular">اطلاعات تماس</p>
              </div>

              <div className="flex flex-col items-start mx-auto mt-4 gap-2 mb-2">
                <p className="text-Title/14/Regular text-gray-600">
                  شماره ثابت:{" "}
                  {telephone_number ? (
                    <a
                      href={`tel:${telephone_number ? telephone_number : ""}`}
                      className="text-Title/20/Bold text-gray-900"
                    >
                      {" "}
                      {telephone_number}{" "}
                    </a>
                  ) : (
                    <span className="text-Title/20/Bold text-gray-900">-</span>
                  )}
                </p>
                {phone_number ? (
                  <a
                    href={`tel:${phone_number ? phone_number : ""}`}
                    className="text-Title/14/Regular text-gray-600"
                  >
                    شماره همراه:{" "}
                    <span className="text-Title/20/Bold text-gray-900">
                      {phone_number}
                    </span>
                  </a>
                ) : (
                  <span className="text-Title/20/Bold text-gray-900">-</span>
                )}
              </div>
              <div className="flex items-center justify-center gap-2 mt-2">
                <p className="text-Title/14/Regular text-gray-600">
                  آدرس:{" "}
                  <span className="text-BodyText/14/Bold text-gray-900">
                    {address}
                  </span>
                </p>
              </div>
            </div>
          ) : modalType === "SelectStore" ? (
            <div className="mx-6 mb-6">
              <div className="flex gap-2">
                <img src="/images/store-logo.png" alt="store logo" />
                <div className="flex flex-col justify-center gap-1">
                  <div className="text-Body-OneLine/14/Bold text-gray-900">
                    {name}
                  </div>
                  <div className="flex ">
                    <img src="/icons/pin-outline.svg" alt="location" />
                    <span className="text-HelpText/11/Regular">
                      {province_name} {" , "}
                    </span>
                    <span className="text-HelpText/11/Regular">
                      {city_name}
                    </span>
                  </div>
                </div>
              </div>
              <hr className="my-2" />
              {!imSure ? (
                <div>
                  <p className="text-Body-OneLine/16/Regular text-gray-500 flex items-center justify-center">
                    آیا از انتخاب این فروشگاه اطمینان دارید؟
                  </p>
                  <div className="flex items-center justify-center gap-4 mt-5">
                    <ButtonComponent
                      type="button"
                      onClick={onClose}
                      variant="outlined"
                      bgColor="bg-gray-600"
                      textColor="text-gray-500"
                      borderColor="border-gray-500"
                    >
                      خیر
                    </ButtonComponent>
                    <ButtonComponent
                      type="button"
                      onClick={() => setImSure(true)}
                    >
                      بله
                    </ButtonComponent>
                  </div>
                </div>
              ) : (
                <>
                  <div className={`${classnamesError}`}>
                    <p className=" text-Body-OneLine/14/Regular text-gray-800 my-6">
                      کالای مورد نظر خود را ثبت نمایید.
                    </p>
                    <TextareaComponent
                      APIgetValue={receivedValue ? receivedValue : ""}
                      latestReceivedValue={receivedValue}
                      editable={true}
                      onChange={(value) => handleValueReceived(value)}
                      value={receivedValue ? receivedValue : undefined}
                      classNameAdded={classnamesError}
                      dynamicRows={8}
                      control={control}
                      placeholder={
                        isEmpty
                          ? "درج اقلام مورد نظر الزامی است."
                          : "اقلام مورد نیاز خود را بنویسید."
                      }
                      name="request_product"
                      errors={errors.request_product as FieldError | undefined}
                    />
                  </div>
                  <div className="flex justify-center items-center gap-5">
                    <ButtonComponent
                      onClick={onClose}
                      variant="outlined"
                      type="button"
                      bgColor="bg-gray-600"
                      textColor="text-gray-500"
                      borderColor="border-gray-500"
                    >
                      لغو
                    </ButtonComponent>
                    <ButtonComponent
                      type="button"
                      onClick={onSubmit}
                      className="w-32"
                      isClicked={isLoading}
                      disabled={isLoading}
                    >
                      ارسال
                    </ButtonComponent>
                  </div>
                </>
              )}
            </div>
          ) : (
            <></>
          )}
        </motion.div>
      </motion.div>
    </motion.div>,
    document.getElementById("modal-root")!
  );
};

export default StoreSelectModal;
